import React, { useEffect, useMemo, useState, useRef } from "react";
import img from "../Whatsapp Marketing/images/wp_Image.png";

const How_WpMarketing = () => {
    const BRAND = "#054E91";

    const STEPS = useMemo(
        () => [
            {
                n: 1,
                title: "Sign up on Vertex Suite",
                desc: "Create your account, connect WhatsApp, and verify your business.",
                img,
            },
            {
                n: 2,
                title: "Optimize your profile",
                desc: "Upload your brand kit, define identity, and add contacts.",
                img,
            },
            {
                n: 3,
                title: "Access Vertex Suite tools",
                desc: "Use chatbots, broadcasts, and sequences to boost marketing.",
                img,
            },
            {
                n: 4,
                title: "Provide user access",
                desc: "Assign roles to team members for smooth operations.",
                img,
            },
        ],
        []
    );

    const [active, setActive] = useState(0);     // 0..3 (current step)
    const [fadeKey, setFadeKey] = useState(0);   // restart image fade
    const [hasStarted, setHasStarted] = useState(false); // after first 3s

    // ===== NEW: animate-on-scroll visibility tracking =====
    const [visible, setVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const ob = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setVisible(true); // fire once
                    ob.disconnect();
                }
            },
            { threshold: 0.2 } // 20% of section visible
        );
        if (sectionRef.current) ob.observe(sectionRef.current);
        return () => ob.disconnect();
    }, []);

    // Auto-advance every ~3s, mark after the first tick so step 1 is static at load
    useEffect(() => {
        const id = setInterval(() => {
            setHasStarted(true);
            setActive((i) => {
                const next = (i + 1) % STEPS.length;
                setFadeKey((k) => k + 1);
                return next;
            });
        }, 3050);
        return () => clearInterval(id);
    }, [STEPS.length]);

    return (
        <section
            ref={sectionRef} // NEW
            className="position-relative"
            style={{
                overflow: "hidden",
                background: "linear-gradient(135deg, #F4F7FC 0%, #E9F1FF 100%)",
                marginTop: 90,
            }}
        >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{ maxWidth: "74%", zIndex: 1 }}
            >
                {/* Heading */}
                <div
                    className={`heading-hero ${visible ? "in-view" : ""}`}
                    style={{ marginTop: 40, textAlign: "center" }}
                >
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        How it works?
                    </h2>
                    <p
                        style={{
                            marginTop: -2,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.2,
                        }}
                    >
                        Our 3-step process makes WhatsApp marketing simple- import contacts
                        from your CRM, build powerful message templates and launch campaigns
                        with complete tracking and optimization.
                    </p>
                </div>

                {/* 4-step row */}
                <div className="steps-grid">
                    {STEPS.map((s, i) => {
                        const isActive = i === active;

                        // For step 1 at initial load (before hasStarted), show full line without animation
                        const shouldAnimate = isActive && (hasStarted || active !== 0);
                        const initialFillWidth =
                            isActive && !hasStarted && active === 0 ? "100%" : "0%";

                        return (
                            <div key={s.n} className="step">
                                {/* Number circle */}
                                <div
                                    className="dot"
                                    aria-current={isActive ? "step" : undefined}
                                    style={{
                                        color: isActive ? "#fff" : BRAND,
                                        background: isActive ? BRAND : "#E7EFFA",
                                        border: `2px solid ${BRAND}`,
                                    }}
                                >
                                    {s.n}
                                </div>

                                {/* Title */}
                                <div className="step-title">{s.title}</div>

                                {/* Description */}
                                <p className="step-desc">{s.desc}</p>

                                {/* Horizontal line under each step */}
                                <div className="line">
                                    <span
                                        key={isActive ? `run-${active}` : `idle-${i}`} // restart only for active
                                        className={`line-fill ${shouldAnimate ? "run" : ""}`}
                                        style={{
                                            background: BRAND,
                                            width: initialFillWidth, // full on first render for step 1
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* image section (fades on step change) */}
                <div className={`preview-wrap ${visible ? "in-view-bottom" : ""}`}> {/* NEW */}
                    <img
                        key={fadeKey}
                        src={STEPS[active].img}
                        alt=""
                        className="preview"
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            </div>

            {/* Styles */}
            <style>{`
        .steps-grid{
          display:grid;
          grid-template-columns: repeat(4, minmax(0,1fr));
          gap: 24px;
          align-items:start;
          margin-top: 60px;
        }

        .step{
          text-align:center;
          padding: 0 8px;
        }

        .dot{
          width: 40px; height: 40px;
          margin: 0 auto 10px;
          border-radius: 999px;
          display: grid; place-items: center;
          font-weight: 800;
          transition: background .35s ease, color .35s ease, transform .2s ease;
        }
        .dot[aria-current="step"]{ transform: scale(1.04); }

        .step-title{
          font-family: Inter;
          font-weight: 600;
          font-size: 20px;
          color: #242121ff;
          margin-bottom: 6px;
          line-height: 1.25;
        }
        .step-desc{
          margin: 0 auto 12px;
          max-width: 280px;
          color: #524e4e;
          font-size: 16px;
          font-family: lato;
          font-weight: 400;
          line-height: 1.2;
        }

        .line{
          position: relative;
          height: 2.6px;
          width: 100%;
          background: #c5c7c9ff;
          border-radius: 999px;
          overflow: hidden;
          margin-top: 30px;
          margin-bottom: 24px;
        }
        .line-fill{
          position: absolute;
          left: 0; top: 0; bottom: 0;
          border-radius: 999px;
          width: 0; /* default */
        }
        /* Active step's bar animates over 3s */
        .line-fill.run{
          animation: lineProgress 3s linear forwards;
        }
        @keyframes lineProgress {
          from { width: 0%; }
          to   { width: 100%; }
        }

        .preview-wrap{
          margin-top: 26px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 26px rgba(15,35,90,.08);
          background: #fff;
          margin-bottom: 70px;

          /* NEW: entrance baseline */
          opacity: 0;
          transform: translateY(18px);
          transition: opacity .8s ease-out, transform .8s ease-out;
        }
        .preview{
          width: 100%;
          height: auto;
          display:block;
          animation: fadeIn .5s ease both;
        }
        @keyframes fadeIn {
          from { opacity:0; transform: translateY(6px); }
          to   { opacity:1; transform: translateY(0); }
        }

        /* NEW: heading entrance */
        .heading-hero{
          opacity: 0;
          transform: translateY(-18px);
          transition: opacity .7s ease-out, transform .7s ease-out;
        }
        .heading-hero.in-view{
          opacity: 1;
          transform: translateY(0);
        }

        /* NEW: image entrance when section visible */
        .preview-wrap.in-view-bottom{
          opacity: 1;
          transform: translateY(0);
        }

        @media (maxWidth: 1024px){
          .steps-grid{ grid-template-columns: 1fr 1fr; gap: 18px; }
        }
        @media (max-width: 1024px){
          .steps-grid{ grid-template-columns: 1fr 1fr; gap: 18px; }
        }
        @media (max-width: 640px){
          .steps-grid{ grid-template-columns: 1fr; }
        }

        /* === step circle no === */
       .step .dot{
            background: #0c5da9ff !important;  
            color: #fff !important;           
            border-color: #0c5da9ff !important;
            width: 30px;                      
            height: 30px;
            font-size: 15px;
            font-family: Oxanium;
            font-weight: 580;
            margin: 0 auto 12px;           
       }

       .step .step-title{
           margin-top: 0;                   
       }

      `}</style>
        </section>
    );
};

export default How_WpMarketing;
